import { Action, createReducer, on } from '@ngrx/store';
import {
    BadResponseWithError,
    Game,
    PlayersProfilesData,
} from '../../models/common.interface';
import { AdminCommonActions } from '../action/actions-type.action';

export interface CommonState {
    games: Game[];
    players: PlayersProfilesData[];
    isLoading: boolean;
    error: BadResponseWithError | null;
    permissionsList: any[];
}

const initialState: CommonState = {
    games: [],
    players: [],
    isLoading: false,
    error: null,
    permissionsList: [],
};

const reducer = createReducer(
    initialState,
    on(AdminCommonActions.fetchPlatformGames, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(AdminCommonActions.fetchPlatformGamesSuccess, (state, action) => ({
        ...state,
        games: action.payload,
        isLoading: false,
    })),
    on(AdminCommonActions.fetchPlatformGamesFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    })),
    on(AdminCommonActions.fetchPlatformPlayers, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(AdminCommonActions.fetchPlatformPlayersSuccess, (state, action) => {
        return {
            ...state,
            players: action.payload,
            isLoading: false,
        };
    }),
    on(AdminCommonActions.fetchPlatformPlayersFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
    })),
    on(AdminCommonActions.fetchPermissionsRequestsSuccess, (state, action) => {
        return {
            ...state,
            permissionsList: action.payload[0].finalizedPermissions,
        };
    })
);

export const commonReducer = (state: CommonState, action: Action) =>
    reducer(state, action);
